/** @format — Mobile header with hamburger menu */

import MobileIconButton from "@/components/MobileIconButton";

export default function DocumentsMobileHeader({
  onMenuClick,
}: {
  onMenuClick?: () => void;
}) {
  return (
    <div className="grid grid-cols-[36px_1fr_36px] items-center gap-2 border-b border-[#E4E7EC] bg-white px-4 py-3 md:hidden">
      <MobileIconButton onClick={onMenuClick} aria-label="Open menu">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="M3 6H21M3 12H21M3 18H21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </MobileIconButton>
      <h1 className="min-w-0 text-center text-[18px] font-semibold text-[#1D2739]">Documents</h1>
      <div className="w-9" aria-hidden />
    </div>
  );
}
